
import { ITrDashboardRes } from '../../models/dashboard/trainer-dashboard';
import { ITrainerBioRes } from '../../models/trainerbio.model';
import getService from '../getService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const TRAINERBIO = 'trainers/details'
const dashboardtr ='trainers/dashboard'

class TrainerBioService {
  
  
  async getTrainerBio() {
    const response = await getService.get(`${CONFIG_API_URL}${TRAINERBIO}`)
    const res :ITrainerBioRes = response.data
    return res;
  }
  async getCourseTrainers() {
    const response = await getService.get(`${CONFIG_API_URL}${TRAINERBIO}`)
    const res :ITrainerBioRes = response.data
    return res;
  }
  async getTrainersDashbord() {
    const response = await getService.get(`${CONFIG_API_URL}${dashboardtr}`)
    const res :ITrDashboardRes = response.data
    return res;
  }
  
 
}

export default new TrainerBioService();